/* REVIVE WEB V2. Video de producto: bucle automatico con dos frenos.
 *
 * El marcado ya sale de Liquid con autoplay, loop y muted, porque el navegador
 * no deja arrancar un video solo si lleva sonido. Aqui se cubre lo que Liquid no
 * puede saber:
 *
 * 1. Movimiento reducido. Si el sistema lo pide, no se arranca nada y se
 *    devuelven los controles, para que quien quiera verlo lo haga a mano. Un
 *    bucle permanente es justo lo que esa preferencia trata de evitar.
 * 2. Fuera de pantalla. Lo que no se ve, se pausa. Un bucle invisible solo gasta
 *    bateria, y la ficha se ve sobre todo en movil.
 */
(function () {
  'use strict';

  var menos = window.matchMedia('(prefers-reduced-motion: reduce)');

  function preparar() {
    var videos = document.querySelectorAll('.rv-galeria video');
    if (!videos.length) return;

    Array.prototype.forEach.call(videos, function (vid) {
      if (menos.matches) {
        vid.autoplay = false;
        vid.loop = false;
        vid.controls = true;
        vid.pause();
        return;
      }

      // Reafirmar en JS lo que ya viene en el marcado: algunos navegadores
      // ignoran el atributo si el video se inserta despues de cargar.
      vid.muted = true;
      vid.loop = true;
      vid.playsInline = true;
      vid.setAttribute('playsinline', '');

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entradas) {
            entradas.forEach(function (e) {
              if (e.isIntersecting) {
                vid.play().catch(function () {});
              } else {
                vid.pause();
              }
            });
          },
          { threshold: 0.25 }
        ).observe(vid);
      } else {
        vid.play().catch(function () {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preparar);
  } else {
    preparar();
  }

  // La galeria puede repintarse al cambiar de variante.
  document.addEventListener('shopify:section:load', preparar);
  if (typeof menos.addEventListener === 'function') {
    menos.addEventListener('change', preparar);
  }
})();
